module.exports = __webpack_public_path__ + "static/media/ic_co_browse_waiting_room.44c2d469.svg";